<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container" (keydown)="keyDownFunction($event)">
    <div class="row">
        <div class="col-16">
            <h1 class="medium">Section 3: Premium Withhold Option</h1>
        </div>
    </div>

    <button #focusableEleTop class="focusable-element"></button>
    <div class="row" *ngIf="hasError">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages"><button>{{error}}</button></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <p class="required">All fields are required, unless marked as optional.</p>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <p class="blue-text">
                Aetna invoices for premiums monthly. {{spnYouenrollee}} can pay your monthly plan premium (including any Part D late enrollment penalty {{spnyoutheenrollee}} may owe) by enrolling in one of our automatic payment methods or {{spnyoutheenrollee}} can elect to receive an invoice in the mail:

                <span class="normalFont" *ngIf="!ShowCurrentYearScript"> 
                    <ul class="listStyleDisc top-padding10">
                        <li><b>&#123;Agent Note-Do <u>not</u> select this option if:</b></li>
                        <li class="marginLeft30">Another program (such as an Employer Group or State Pharmaceutical Assistance Program (SPAP)) is paying part of their premium.</li>
                        <li class="marginLeft30">They are enrolling in a plan with a $0 premium and you do not owe a late enrollment penalty&#125;</li>
                    </ul>
                </span>
            </p>
            <fieldset class="radio">
                <ValidatedRadioButtonGroup [options]="paymentOptions"
                                           [selectedValue]="enrollment.paymentOption"
                                           [radioGroupName]="'PaymentOptions'"
                                           [disabled]="disabled"
                                           (onValueChange)="paymentOptionChanged($event)">
                </ValidatedRadioButtonGroup>
                <legend class="blue-text">How would {{spnyoutheenrollee}} like to pay for the monthly premium?</legend>
            </fieldset>
        </div>
    </div>

    <div class="row" *ngIf="IsAutomatciSocial">
        <div class="col-16" *ngIf="ShowCurrentYearScript">
            <div class="bottom-20">
                <p class="blue-text">Aetna will deduct {{spnIsBeneficiaryYour}} monthly premium from {{spnyourtheenrollee}}  Social Security Benefit automatically.  {{spnYourenrollee}} request for premium deduction will be submitted to CMS to approve for the next available payment cycle.  Social Security Benefit Withholding may take two or more months to begin once approved and {{spnyoutheenrollee}} will be responsible for premiums due prior to {{spnyourtheenrollee}} withholding effective date. If {{spnyourtheenrollee}} request is not approved  for automatic deduction, we will send {{spnyouthem}} a paper bill for {{spnyourtheenrollee}} monthly premiums.</p>
            </div>
        </div>
        <div class="col-16" *ngIf="!ShowCurrentYearScript">
            <div class="bottom-20">
                <p class="blue-text">Aetna will deduct {{spnIsBeneficiaryYour}} monthly premium from {{spnyourtheenrollee}}  Social Security Benefit automatically.  {{spnYourenrollee}} request for premium deduction will be submitted to CMS to approve for the next available payment cycle.  Social Security Benefit Withholding may take two or more months to begin once approved and {{spnyoutheenrollee}} will be responsible for premiums due prior to {{spnyourtheenrollee}} withholding effective date. If {{spnyourtheenrollee}} request is not approved  for automatic deduction, we will send {{spnyouthem}} a paper bill for {{spnyourtheenrollee}} monthly premiums.</p>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="IsAUTOMATIC_RAILROAD">
        <div class="col-16" *ngIf="ShowCurrentYearScript">
            <div class="bottom-20">
                <p class="blue-text">Aetna will deduct {{spnIsBeneficiaryYour}} monthly premium from {{spnyourtheenrollee}}  Railroad Retirement Board Benefit automatically.  {{spnYourenrollee}} request for premium deduction will be submitted to CMS to approve for the next available payment cycle.  Railroad Retirement Board Benefit Withholding may take two or more months to begin once approved and {{spnyoutheenrollee}} will be responsible for premiums due prior to {{spnyourtheenrollee}} withholding effective date. If {{spnyourtheenrollee}} request is not approved  for automatic deduction, we will send {{spnyouthem}} a paper bill for {{spnyourtheenrollee}} monthly premiums.</p>
            </div>
        </div>
        <div class="col-16" *ngIf="!ShowCurrentYearScript">
            <div class="bottom-20">
                <p class="blue-text">Aetna will deduct {{spnIsBeneficiaryYour}} monthly premium from {{spnyourtheenrollee}}  Railroad Retirement Board Benefit automatically.  {{spnYourenrollee}} request for premium deduction will be submitted to CMS to approve for the next available payment cycle.  Railroad Retirement Board Benefit Withholding may take two or more months to begin once approved and {{spnyoutheenrollee}} will be responsible for premiums due prior to {{spnyourtheenrollee}} withholding effective date. If {{spnyourtheenrollee}} request is not approved  for automatic deduction, we will send {{spnyouthem}} a paper bill for {{spnyourtheenrollee}} monthly premiums.</p>
            </div>
        </div>
    </div>

    <div *ngIf="IsElectronicFund">
        <div class="row">
            <div class="col-16">
                <div class="bottom-20">
                    <p class="blue-text">I can set up {{spnyourtheenrollee}} Automatic deduction today. First I must read {{spnyoutheenrollee}} a statement and provide {{spnyoutheenrollees}} with some information regarding the Automatic Bank Draft withdrawal process. At the end of the statement, I will ask {{spnyoutheenrollees}} to provide a verbal authorization agreeing to the terms and conditions.</p>
                    <p class="blue-text">
                        By agreeing to enroll in Automatic Bank Draft Withdrawal, {{spnIsBeneficiary}} {{spnauthorize}} the bank or financial organization provided during this call to pay your premium through electronic bank withdrawal payable to Aetna Insurance Company. We will withdraw the total amount due on your account.
                        
                        <span *ngIf="!ShowCurrentYearScript">This includes your current monthly premium payment, as well as any past due payments at the time of the monthly draft.</span>
                        
                        The bank or other financial organization will be fully protected in honoring these payments until verbal or written notice from you canceling this request is received. Automatic deductions occur once a month between the 1st and 10th, and will begin once your enrollment becomes effective. If you have any questions about your Automatic Payment status, you may call 1-855-651-4856 24 hours a day, 7 days a week TTY users can call 711 Do you agree to these terms and conditions provided to you on {{currentdate}}?
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p class="red-text">I can set up {{spnyourtheenrollee}} Automatic Payments Today, can I have the:</p>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField class="field field--single"
                                        [label]="'Name on Account (Alphanumeric Characters Only):'"
                                        id="name-on-account"
                                        [text]="enrollment.ACCHOLDERNAME"
                                        [disabled]="disabled"
                                        (onValueChange)="enrollment.ACCHOLDERNAME = $event"
                                        [validators]="[]">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <fieldset class="radio">
                    <legend>Type of Account</legend>
                    <ValidatedRadioButtonGroup id="account-type"
                                               radioGroupName="account-type-radio-group"
                                               [options]="accountTypeOptions"
                                               [selectedValue]="enrollment.EFTTYPE"
                                               [disabled]="disabled"
                                               (onValueChange)="enrollment.EFTTYPE = $event"
                                               [validators]="[]">
                    </ValidatedRadioButtonGroup>
                </fieldset>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField class="field field--single"
                                        [label]="'Financial Institution (Alphanumeric Characters Only):'"
                                        id="financial-institution"
                                        [text]="enrollment.FININSTNAME"
                                        [disabled]="disabled"
                                        (onValueChange)="enrollment.FININSTNAME = $event"
                                        [validators]="[]">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField class="field field--single"
                                        [label]="'Routing Number'"
                                        id="routing-number"
                                        [text]="enrollment.ROUTINGNB"
                                        (onValueChange)="enrollment.ROUTINGNB = $event"
                                        [maxlength]="9"
                                        [disabled]="disabled"
                                        [validators]="[]">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField class="field field--single"
                                        [label]="'Account Number'"
                                        id="account-number"
                                        [text]="enrollment.ACCOUNTNB"
                                        [disabled]="disabled"
                                        [maxlength]="15"
                                        (onValueChange)="enrollment.ACCOUNTNB = $event"
                                        [validators]="[]">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p class="bottom-20"><strong class="red-text">qTip Note:</strong> Routing number is the 9 digits number found on the bottom left corner of the check. This is usually followed by the account number and then the check number. When speaking with the member, ask them to not include the check number with the account number.</p>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="IsMonthly">
        <div class="col-16">
            <div class="bottom-20" *ngIf="ShowCurrentYearScript">
                <p class="blue-text">{{spnYouTheenrollee}} can pay {{spnyourtheenrollee}} monthly bill at <a class="link" href="https://www.aetnamedicare.com" target="_blank">AetnaMedicare.com</a>, at any CVS Pharmacy®, except those inside Target stores and Schnucks Pharmacy, or by mail.  Please see the bill for details.  For Automatic payments from {{spnyourtheenrollee}} credit card, please call the number on {{spnyourtheenrollee}} bill for set up instructions.  </p>
            </div>
        </div>
        <div class="col-16">
            <div class="bottom-20" *ngIf="!ShowCurrentYearScript">
                <p class="blue-text">{{spnYouTheenrollee}} can pay {{spnyourtheenrollee}} monthly bill at <a class="link" href="https://www.aetnamedicare.com" target="_blank">AetnaMedicare.com</a>, at any CVS Pharmacy®, except those inside Target stores and Schnucks Pharmacy, or by mail.  Please see the bill for details.  For Automatic payments from {{spnyourtheenrollee}} credit card, please call the number on {{spnyourtheenrollee}} bill for set up instructions.  </p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16" *ngIf="IsShowScript">
            <div class="bottom-20">
                <p class="blue-text" *ngIf="ShowCurrentYearScript">If {{spnIsBeneficiary}} {{spnIsQualify}} for Extra Help with {{spnyourhisher}} Medicare prescription drug coverage costs, Medicare will pay all or part of {{spnyourtheenrollee}} plan premium.</p>
                <p class="blue-text" *ngIf="!ShowCurrentYearScript">If {{spnIsBeneficiary}} {{spnIsQualify}} for Extra Help with {{spnYourTheir}} Medicare prescription drug coverage costs, Medicare will pay all or part of {{spnyourtheenrollee}} plan premium.</p>
                <p class="blue-text">If Medicare pays only a portion of this premium, we will charge {{spnIsBeneficiary}} for the amount that Medicare does not cover.</p>
            </div>
        </div>
        <div class="col-16" *ngIf="IsShowScript">
            <div class="bottom-20">
                <p class="blue-text" *ngIf="ShowCurrentYearScript">
                    I would like to let you know that people with limited incomes may qualify for Extra Help from Medicare to help pay for drug costs, including monthly prescription drug premiums, annual deductibles, copays and coinsurance. Additionally, those who qualify won’t have a coverage gap or a Part D late enrollment penalty.  For more information about Extra Help, they can be reached at
                    1-800-772-1213 between 7 AM and 7 PM Monday through Friday or you can use their automated telephone service 24 hours a day. TTY users should call 1-800-325-0778. You can also apply for Extra Help online at  <a class="link" href="https://www.ssa.gov/benefits/medicare/prescriptionhelp/" target="_blank">https://www.ssa.gov/benefits/medicare/prescriptionhelp/</a>.
                </p>
                <p class="blue-text normalFont" *ngIf="!ShowCurrentYearScript">
                    <br />
                    <span>
                        <ul class="listStyleDisc">
                            <li>Social Security will contact you if you have to pay a Part D-Income Related Monthly Adjustment Amount (Part D IRMAA). You’ll have to pay this extra amount as well as your plan premium. You will either have the amount withheld from your SSA or RRB benefit check or be billed directly by Medicare or the RRB.<b>Do not send your Part D IRMAA payment to us.</b></li>
                            <li>People with limited incomes may qualify for Extra Help to pay for their prescription drug costs. If eligible, Medicare could pay for 75% or more of your drug costs, including monthly prescription drug premiums, annual deductibles, and co-insurance. Additionally, those who qualify will not be subject to the coverage gap or a late enrollment penalty. Many people are eligible for these savings and don’t even know it. For more information about this Extra Help, contact your local Social Security office, or call Social Security at <b>1-800-772-1213 (TTY: 1-800-325-0778)</b>. You can also apply for Extra Help online at <a class="link" href="https://www.socialsecurity.gov/prescriptionhelp" target="_blank">www.socialsecurity.gov/prescriptionhelp</a>.</li>
                        </ul>
                    </span>
                    <br />
                    If you qualify for Extra Help with your Medicare prescription drug coverage costs, Medicare will pay all or part of your plan premium. If Medicare pays only a portion of this premium, we will bill you for the amount that Medicare doesn’t cover.
                </p>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="IsShowScript">
        <div class="col-16">
            <label>Notes (max 300 characters)</label>
            <textarea rows="3" cols="60" name="txtNotes" [(ngModel)]="enrollment.NOTES" maxlength="300"></textarea>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button class="button primary" (click)="formSubmit()">Continue</button>
            <button class="button cancel" (click)="onBack()">Back</button>
        </div>
    </div>
</div>
